import { createRootRoute } from '@tanstack/react-router';

import { BaseLayout } from '@/components/layouts/base-layout';

export const Route = createRootRoute({
  component: BaseLayout,
});
